import { render, staticRenderFns } from "./SettingsNeopag.vue?vue&type=template&id=d78704de&"
import script from "./SettingsNeopag.vue?vue&type=script&lang=js&"
export * from "./SettingsNeopag.vue?vue&type=script&lang=js&"
import style0 from "./SettingsNeopag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports